import { FormLabel as MuiFormLabel } from '@mui/material';
import { useId } from 'react';

import { Stack } from '../Stack/Stack';
import { Text } from '../Text/Text';
import { useColors } from '../ThemeProvider';

type Props = {
  componentId: string;
  id?: string;
  label: string;
  required: boolean;
  valid: boolean;
  disabled?: boolean;
};

export function FormLabel({ componentId, id, label, required, valid, disabled = false }: Props) {
  const generatedId = useId();
  const labelId = id ?? generatedId;
  const { textPrimary, textSecondary } = useColors();
  const labelColor = disabled ? textSecondary : textPrimary;

  return (
    <MuiFormLabel
      htmlFor={componentId}
      id={labelId}
      sx={{
        color: labelColor,
        pointerEvents: 'none',
        opacity: disabled ? 0.7 : 1,
      }}
    >
      <Stack direction="row" gap="0.2rem">
        {required && <Text color={valid ? 'primary' : 'error'}>{'*'}</Text>}
        <Text>{label}</Text>
      </Stack>
    </MuiFormLabel>
  );
}
